"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var material_ui_image_1 = require("material-ui-image");
var core_1 = require("@material-ui/core");
var carImageWithBgStyles_1 = require("./carImageWithBgStyles");
var useBackgroundImage_1 = require("../../../../../common/hooks/useBackgroundImage");
var CarImageWithBg = function (_a) {
    var imageSrc = _a.imageSrc, interiorImg = _a.interiorImg;
    var styles = carImageWithBgStyles_1.default();
    var _b = useBackgroundImage_1.useBackgroundImage(), backgroundImage = _b.backgroundImage, isDefaultBackground = _b.isDefaultBackground, loading = _b.loading;
    var imageContent = (<core_1.Box className={styles.bgContainer}>
      <material_ui_image_1.default src={backgroundImage} style={carImageWithBgStyles_1.carImageStyles.vehicleImageRoot} imageStyle={carImageWithBgStyles_1.carImageStyles.vehicleImage}/>
    </core_1.Box>);
    if (!loading && isDefaultBackground) {
        imageContent = (<>
        <core_1.Box className={styles.bgContainer}>
          <material_ui_image_1.default src={backgroundImage} style={carImageWithBgStyles_1.carImageStyles.backgroundImageRoot} imageStyle={carImageWithBgStyles_1.carImageStyles.backgroundImage} data-test="summary:car-image_background"/>
          <material_ui_image_1.default src={interiorImg} style={carImageWithBgStyles_1.carImageStyles.interiorImageRoot} imageStyle={carImageWithBgStyles_1.carImageStyles.interiorImage} data-test="summary:car-image_interior"/>
        </core_1.Box>
        <material_ui_image_1.default src={imageSrc} style={__assign(__assign({}, carImageWithBgStyles_1.carImageStyles.vehicleImageRoot), carImageWithBgStyles_1.carImageStyles.vehicleImagePosition)} imageStyle={carImageWithBgStyles_1.carImageStyles.vehicleImage}/>
      </>);
    }
    return <core_1.Box className={styles.imageContainer}>{imageContent}</core_1.Box>;
};
exports.default = CarImageWithBg;
